import React, { useState, useEffect } from "react";
import {
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Button,
  Row,
  Col,
} from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import PropTypes from "prop-types";

import style from "../../Grid.module.scss";
import { BankAccountType, BankAccountStatus } from "../types";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalBankAccount from "../../Modal/ModalBankAccount";
import { CircularProgress } from "../../../..";
import { AccountMode, showToast } from "../../../../utils/Helper";
import Groups from "../../../Asset/Tabs/Groups/Groups";

function generateEmptyBankAccount() {
  return {
    PersonBankAccountBankId: "",
    PersonBankAccountItemId: "",
    PersonBankAccountName: "",
    PersonBankAccountHolders: undefined,
    PersonBankAccountBranch: undefined,
    PersonBankAccountNumber: undefined,
    PersonBankAccountCurrency: 1,
    PersonBankAccountIsDepositInterest: false,
    PersonBankAccountPersonalName: "",
    PersonBankAccountObs: "",
    PersonBankAccountType: BankAccountType.Savings,
    PersonBankAccountStatus: BankAccountStatus.Active,
    Archives: [],
  };
}

const BankAccountsTab = ({
  person,
  bankAccounts,
  currencies,
  banks,
  setPersonData,
  services,
  userType,
  mode,
  setRedirectAccounts,
  sended,
  references,
  signatureSets,
  groups,
  onboarding,
  accountId,
  userSession,
  newOnboardingVersion = false,
  getBankAccounts = false,
  tabIsReadOnly = false,
}) => {
  const [fetching, setFetching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    bankAccountItemId: undefined,
    saving: false,
    callback: undefined,
  });
  const [modalBankAccount, setModalBankAccount] = useState({
    open: false,
    saving: false,
    bankAccount: generateEmptyBankAccount(),
    errors: {},
  });
  const [archives, setArchives] = useState([]);
  const toggleModalConfirm = () => {
    setModalConfirm({
      open: false,
      title: "",
      bankAccountItemId: undefined,
      saving: false,
      callback: undefined,
    });
  };

  const validateBranchOffice = (value) => {
    if (isNaN(value)) {
      return false;
    }
  
    if (value.length > 4) {
      return false;
    }
  
    return true;
  };
  

  const onChangeEdit = (name, value, strValue) => {
    let newValue = value;
    if (name === "PersonBankAccountIsDepositInterest" || name === "PersonBankAccountFavorite") {
      newValue = value === "true" || value === true;
    }

    if (name === "PersonBankAccountBranch") {
      if (!validateBranchOffice(value)) {
        return;
      }
    }

    setModalBankAccount({
      ...modalBankAccount,
      bankAccount: {
        ...modalBankAccount.bankAccount,
        [name]: newValue,

        PersonBankAccountName:
          name === "PersonBankAccountBankId" ? strValue : modalBankAccount.bankAccount.PersonBankAccountName,
      },
    });
  };

  const toggleModalBankAccount = (bankAccount) => {
    if (bankAccount !== undefined) {
      if (bankAccount.Archives !== undefined) {
        setArchives(bankAccount.Archives);
      } else {
        setArchives([]);
      }
    } else {
      setArchives([]);
    }
    setModalBankAccount({
      saving: modalBankAccount.saving,
      open: !modalBankAccount.open,
      bankAccount:
        bankAccount && bankAccount.PersonBankAccountItemId ? bankAccount : generateEmptyBankAccount(),
      errors: {},
    });
  };

  const isReadOnly = () => {
    return userSession.IsReadOnly || tabIsReadOnly
  }

  const handleEdit = (index) => {
    toggleModalBankAccount(bankAccounts[index]);
  };

  const handleAdd = () => {
    toggleModalBankAccount();
  };

  const handleDelete = (index) => {
    const id = bankAccounts[index].PersonBankAccountItemId;
    setModalConfirm({
      open: true,
      title: "Are you sure you want to delete the selected Bank Account?",
      bankAccountItemId: id,
      callback: () => deleteBankAccount(id),
    });
  };

  function validateBankAccount(fields) {
    const fieldNames = ["PersonBankAccountBankId", "PersonBankAccountPersonalName"];
    const errors = {};

    fieldNames.forEach((name) => {
      if (fields[name] == undefined || fields[name] == "") {
        errors[name] = "Required field";
      }
    });

    return errors;
  }

  const handleSaveBankAccount = () => {
    const errors = validateBankAccount(modalBankAccount.bankAccount);
    setModalBankAccount({
      ...modalBankAccount,
      errors: errors,
    });
    if (Object.keys(errors).length == 0) {
      const newBankAccount = { ...modalBankAccount.bankAccount };
      setModalBankAccount({ ...modalBankAccount, saving: true });
      if (!onboarding) {
        const body = {
          person: {
            PersonId: person.PersonId,
            PersonBankAccount: [newBankAccount],
            isOnboardingPerson: person.isOnboardingPerson,
          },
          isadministrator: newOnboardingVersion ? true : false,
          delete: false,
        };
        services.fetchUpdatePersonBankAccount(body, (response) => {
          if (response && response.result && response.result.Code === 200) {
            if(getBankAccounts){
                const body = {
                personId : person.PersonId
              }
              services.fetchGetPersonBankAccounts(body, (response1) => {
                if (response1 && response1.bankAccounts && response1.result.Code === 200){
                  const newBankAccounts = response1.bankAccounts;
                  const newPerson = {
                    ...person,
                    PersonBankAccount: newBankAccounts,
                  }
                  setModalBankAccount({
                    ...modalBankAccount,
                    open: false,
                    loading: false,
                  });
                  setPersonData(newPerson);
                } else {
                  setModalBankAccount({
                    ...modalBankAccount,
                    loading: false,
                  });
                  if (response.result && response.result.Description) {
                    showToast("Error:" + response.result.Description, "error");
                  } else {
                    showToast("Error saving bank account", "error");
                  }
                }
              })
            }else{
              if (response.result.Description === "") {
                let docs = person.PersonBankAccount ? person.PersonBankAccount : [];
                let id = response.Id;
                if (newBankAccount.PersonBankAccountItemId > 0) {
                  id = newBankAccount.PersonBankAccountItemId;
                  docs.forEach((p, i) => {
                    if (p.PersonBankAccountItemId == newBankAccount.PersonBankAccountItemId) {
                      docs.splice(i, 1);
                    }
                  });
                }
                const nArchive = {
                  ...newBankAccount,
                  PersonBankAccountItemId: id,
                };
                docs.push(nArchive);
                setModalBankAccount({
                  ...modalBankAccount,
                  open: false,
                  loading: false,
                });
              } else {
                setModalBankAccount({
                  ...modalBankAccount,
                  open: false,
                  loading: false,
                });
                showToast(response.result.Description);
              }
            }
          } else {
            setModalBankAccount({
              ...modalBankAccount,
              loading: false,
            });
            if (response.result && response.result.Description) {
              showToast("Error:" + response.result.Description, "error");
            } else {
              showToast("Error saving bank account", "error");
            }
          }
        });
      } else {
        let docs = person.PersonBankAccount ? person.PersonBankAccount : [];
        let id = bankAccounts ? Number(bankAccounts.length) + 2 : 1;
        if (newBankAccount.PersonBankAccountItemId > 0) {
          id = newBankAccount.PersonBankAccountItemId;
          docs.forEach((p, i) => {
            if (p.PersonBankAccountItemId == newBankAccount.PersonBankAccountItemId) {
              docs.splice(i, 1);
            }
          });
        }
        const nArchive = {
          ...newBankAccount,
          PersonBankAccountItemId: id,
        };

        docs.push(nArchive);
        const postPerson = {
          ...person,
          PersonBankAccount: docs,
        };
        const body2 = {
          postPerson: postPerson,
          OnboardingId: onboarding,
        };
        services.fetchNewPerson(body2, (response) => {
          if (response && response.result && response.result.Code === 200) {
            setPersonData(postPerson);
            setModalBankAccount((m) => ({
              saving: false,
              open: false,
              bankAccount: generateEmptyBankAccount(),
              errors: undefined,
            }));
          } else {
            setModalBankAccount({
              ...modalBankAccount,
              saving: false,
              open: false,
            });
          }
        });
      }
    }
  };

  const deleteBankAccount = (id) => {
    const deleteAccountId = id;
    let bankAccountToDelete = person.PersonBankAccount.filter(
      (bankAccount) => bankAccount.PersonBankAccountItemId === deleteAccountId
    );

    const personsend = {
      ...person,
      PersonBankAccount: [
        {
          ...bankAccountToDelete[0],
        },
      ],
    };
    setModalConfirm({ ...modalConfirm, saving: true });
    if (!onboarding) {
      const body = {
        person: {
          ...personsend, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
        isadministrator: newOnboardingVersion ? true : false,
        delete: true,
      };
      services.fetchUpdatePersonBankAccount(body, (response) => {
        if (response && response.result && response.result.Code === 200) {
          const newBankAccounts = bankAccounts;
          let index = -1;
          newBankAccounts.map((bankAcc, i) => {
            if (deleteAccountId === bankAcc.PersonBankAccountItemId) {
              index = i;
            }
            return {};
          });
          if (index > -1) {
            newBankAccounts.splice(index, 1);
          }
          toggleModalConfirm();
        } else {
          setModalConfirm({
            ...modalConfirm,
            saving: false,
          });
          alert(response.result.Description);
        }
      });
    } else {
      let docs = person.PersonBankAccount;
      docs.forEach((p, i) => {
        if (p.PersonBankAccountItemId == id) {
          docs.splice(i, 1);
        }
      });

      const postPerson = {
        ...person,
        PersonBankAccount: docs,
      };
      const body2 = {
        postPerson: postPerson,
        OnboardingId: onboarding,
      };
      services.fetchNewPerson(body2, (response) => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(postPerson);
          setModalBankAccount((m) => ({
            saving: false,
            open: false,
            bankAccount: generateEmptyBankAccount(),
            errors: undefined,
          }));
        } else {
          setModalBankAccount({
            ...modalBankAccount,
            saving: false,
            open: false,
          });
        }
      });
    }
  };

  const handleCreateAccount = () => {
    setLoading(true);
    const body = {
      onboardingProcessId: accountId,
    };
    services.createAccount(body, (data) => {
      if (data && data.result) {
        setModalConfirm({
          ...modalConfirm,
          saving: false,
          open: false,
        });
        if (data.result.Code === 200) {
          alert("Account Sended to Compliance!");
          setRedirectAccounts(true);
        } else {
          alert(`Failed! ${data.result.Description}`);
        }
      }
      setLoading(false);
    });
  };

  const createOnboardingAccount = () => {
    setModalConfirm((m) => ({
      ...m,
      open: true,
      title: "Are you sure you want to send this account to compliance?",
      accountId,
      callback: () => handleCreateAccount(accountId),
    }));
  };

  const getCurrencyISO = (id) => {
    let iso = "";
    if (currencies) {
      currencies.forEach((c) => {
        if (parseInt(c.currencyId, 10) === parseInt(id, 10)) {
          iso = c.currencyISO;
        }
      });
    }
    return iso;
  };

  const getFile = (file) => {
    if (mode === AccountMode.New) {
      const body = {
        fileId: file.ArchiveTemporalFileId,
        onboarding: accountId,
      };
      services.getOnboardingAccountArchive(body, (response) => {
        var a = document.createElement("A");
        a.href = `data:application/octet-stream;base64,${response.blobfile}`;
        a.download = `${file.ArchiveName}.${file.ArchiveExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    } else {
      const body = {
        accountId: accountId,
        archiveId: file.ArchiveId,
      };
      services.getAccountArchive(body, (response) => {
        var a = document.createElement("A");
        a.href = `data:application/octet-stream;base64,${response.blobfile}`;
        a.download = `${file.ArchiveName}.${file.ArchiveExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
    }
  };

  return (
    <div>
      <Table className={style.table}>
        <thead>
          <tr>
            <th style={{ maxWidth: 50 }}> </th>
            <th style={{ maxWidth: 70 }}>#</th>
            <th>Currency</th>
            <th>Type</th>
            <th>Name</th>
            <th>Holders</th>
            <th>Default Permanent Instruction</th>
            <th>Fund Incomes only</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {fetching ? (
            <tr>
              <td colSpan={5}>
                <CircularProgress sm />
              </td>
            </tr>
          ) : (
            <React.Fragment>
              {bankAccounts && bankAccounts.length > 0 ? (
                bankAccounts.map((acc, i) => (
                  <tr key={acc.PersonBankAccountItemId}>
                    <td style={{ width: 50 }}>
                    {
                      !isReadOnly() && 
                      <RenderDropdownActions index={i} onDelete={handleDelete} onEdit={handleEdit} />
                    }
                    </td>
                    <td style={{ width: 70 }}>{acc.PersonBankAccountNumber}</td>
                    <td>{getCurrencyISO(acc.PersonBankAccountCurrency)}</td>
                    <td>{acc.PersonBankAccountType}</td>
                    <td>{acc.PersonBankAccountName}</td>
                    <td>{acc.PersonBankAccountHolders}</td>
                    <td>{acc.PersonBankAccountIsDepositInterest ? "Yes" : "No"}</td>
                    <td>{acc.PersonBankAccountFundIncomesOnly ? "Yes" : "No"}</td>
                    <td>{acc.PersonBankAccountStatus}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} style={{ textAlign: "center" }}>
                    No Results.
                  </td>
                </tr>
              )}
            </React.Fragment>
          )}
        </tbody>
      </Table>
      {!isReadOnly() && <Button color="primary" onClick={handleAdd}>
        <i className="fa fa-plus" /> Add Bank Account
      </Button>}
      <ModalConfirm {...modalConfirm} toggle={toggleModalConfirm} />
      <ModalBankAccount
        {...modalBankAccount}
        toggle={toggleModalBankAccount}
        onChange={onChangeEdit}
        onSave={handleSaveBankAccount}
        currencies={currencies}
        banks={banks}
        errors={modalBankAccount.errors}
        archives={archives}
        setArchives={setArchives}
        getFile={getFile}
      />
      {userType === "Advisor" && !sended && (
        <Row>
          <Col style={{ textAlign: "right" }}>
            <LaddaButton
              className="btn btn-ladda btn-primary"
              loading={loading}
              onClick={createOnboardingAccount}
              data-style={EXPAND_RIGHT}
            >
              Create Account
            </LaddaButton>
          </Col>
        </Row>
      )}
    </div>
  );
};

BankAccountsTab.propTypes = {
  accountId: PropTypes.string.isRequired,
  bankAccounts: PropTypes.array.isRequired,
  setAccountData: PropTypes.func.isRequired,
  currencies: PropTypes.array.isRequired,
  services: PropTypes.object.isRequired,
  banks: PropTypes.array,
};

BankAccountsTab.defaultProps = {
  banks: undefined,
};

function RenderDropdownActions({ onEdit, onDelete, index }) {
  return (
    <UncontrolledDropdown>
      <DropdownToggle color="link" size="lg" className={style.dropdown}>
        <i className="icon-options-vertical icons d-block" />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => onEdit(index)}>
          <i className="fa fa-edit" />
          Edit
        </DropdownItem>
        <DropdownItem onClick={() => onDelete(index)}>
          <i className="fa fa-trash" />
          Delete
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

RenderDropdownActions.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default BankAccountsTab;
